function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import styled from 'styled-components';
import { Image, ImageEntity, Typography } from '@fupa/fupa-uikit';
import { LinkOnComponent } from 'app/components/links/link';
const StyledProfileTeam = styled.div.withConfig({
  componentId: "sc-1a57h68-0"
})(["display:inline-flex;align-items:center;gap:0.25rem;padding:0.25rem 0.75rem 0.25rem 0.25rem;width:fit-content;border-radius:2.5rem;overflow:hidden;text-overflow:ellipsis;margin-top:0.5rem;min-height:2.5rem;"]);
const Emblem = styled(Image).withConfig({
  componentId: "sc-1a57h68-1"
})(["&&&{height:2rem;width:2rem;}"]);
const EllipsisTypography = styled(Typography).withConfig({
  componentId: "sc-1a57h68-2"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
export const ProfileTeam = _ref => {
  let {
    currentTeam
  } = _ref;
  let linkProps = {};
  if (!currentTeam) {
    return /*#__PURE__*/React.createElement(StyledProfileTeam, null);
  }
  if (currentTeam !== null && currentTeam !== void 0 && currentTeam.url) {
    linkProps = {
      as: LinkOnComponent,
      enablehover: true,
      to: currentTeam.url
    };
  }
  return /*#__PURE__*/React.createElement(StyledProfileTeam, _extends({}, linkProps, {
    "data-sentry-element": "StyledProfileTeam",
    "data-sentry-component": "ProfileTeam",
    "data-sentry-source-file": "ProfileTeam.tsx"
  }), /*#__PURE__*/React.createElement(Emblem, {
    entity: ImageEntity.Emblem,
    src: currentTeam.image,
    ratio: '1:1',
    height: 32,
    width: 32,
    eager: true,
    fit: true,
    fetchPriority: 'high',
    "data-sentry-element": "Emblem",
    "data-sentry-source-file": "ProfileTeam.tsx"
  }), /*#__PURE__*/React.createElement(EllipsisTypography, {
    variant: 'subheading',
    "data-sentry-element": "EllipsisTypography",
    "data-sentry-source-file": "ProfileTeam.tsx"
  }, currentTeam.name));
};